<div class="inline-profile">
    Vitajte!

    <div><button class="btn btn-sm btn-outline-info" (click)="logout()">Logout</button></div>
</div>
